export default __webpack_public_path__ + "static/media/108.1facb0b8.jpg";